import { render, staticRenderFns } from "./AddManagerPopup.vue?vue&type=template&id=384a1b16"
import script from "./AddManagerPopup.vue?vue&type=script&lang=ts"
export * from "./AddManagerPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddManagerPopup.vue?vue&type=style&index=0&id=384a1b16&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports